<button type="button" class="btn text-start fw-bold buttonClose" aria-label="Close" (click)="onSubmit()">
  <span>{{"action.close" | translate}}</span>
</button>
